angular.module('autoremind.satellites.services', [])
    .factory('satelliteService', ['$q', '$log', '$enhancedHttp',
    function ($q, $log, $enhancedHttp) {
        var satelliteService = {};
        satelliteService.userSchedulerStatuses = [{
                id: 'all',
                text: 'Scheduler: all',
                group: "B",
                type: 'scheduler',
                // isAll : true,
                isMasterType: true
            }, {
                id: 'active',
                text: 'Scheduler: active',
                group: "B",
                type: 'scheduler'
            }, {
                id: 'pause',
                text: 'Scheduler: pause',
                group: "B",
                type: 'scheduler'
            }];
        satelliteService.userstatuses = [];
        satelliteService.getSatellite = function (satelliteId, account) {
            $log.debug('satelliteService.getSatellite(' + satelliteId + ')');
            var deferred = $q.defer();
            $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/' + satelliteId + '/' + account + '/'
            })
                .then(function (data, status) {
                //model.inProgress = false;
                deferred.resolve(data.satellites); // TODO: Handle errors if no satellites
            }, function (data, status) {
                //model.inProgress = false;
                $log.error('Error getting salittes data from server');
                deferred.reject(status);
            });
            return deferred.promise;
        };
        satelliteService.satelliteVersionLatest = 'latest version';
        satelliteService.satelliteLogServiceUIUrl = null;
        satelliteService.getSatellites = function (account) {
            $log.debug('satelliteService.getSatellites()');
            var deferred = $q.defer();
            var url = '/servlets/satellites/user/';
            if (account) {
                url += account + '/';
            }
            $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Failed getting satellites from server',
                disableErrorDialog: true
            })
                .then(function (data, status) {
                //model.inProgress = false;
                deferred.resolve(data.satellites); // TODO: Handle errors if no satellites
            }, function (data, status) {
                //model.inProgress = false;
                $log.error('Error getting salittes data from server');
                deferred.reject(status);
            });
            return deferred.promise;
        };
        satelliteService.getLatestVersion = function (account) {
            $log.debug('satelliteService.getLatestVersion()');
            var deferred = $q.defer();
            var url = '/servlets/satellites/latestversion/';
            $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Failed getting latest satellite version from server',
                disableErrorDialog: true
            })
                .then(function (data, status) {
                //model.inProgress = false;
                satelliteService.satelliteVersionLatest = data.satelliteVersionLatest;
                deferred.resolve(data.satellites); // TODO: Handle errors if no satellites
            }, function (data, status) {
                //model.inProgress = false;
                $log.error('Error getting salittes data from server');
                deferred.reject(status);
            });
            return deferred.promise;
        };
        satelliteService.getLogServiceUIUrl = function () {
            $log.debug('satelliteService.getLogServiceUIUrl()');
            var deferred = $q.defer();
            var url = '/servlets/satellites/logserviceuiurl/';
            $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Failed getting log service UI URL',
                disableErrorDialog: true
            })
                .then(function (data, status) {
                satelliteService.satelliteLogServiceUIUrl = data.satelliteLogServiceUIUrl;
                deferred.resolve(data.satelliteLogServiceUIUrl);
            }, function (data, status) {
                $log.error('Error getting satellite log service ui url');
                deferred.reject(status);
            });
            return deferred.promise;
        };
        satelliteService.getDatasourcesDefaults = function (loadingIndicator) {
            var url = '/servlets/satellites/datasourcesdefaults/';
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Failed getting datasources defaults from server',
                disableErrorDialog: true
            }, loadingIndicator);
        };
        satelliteService.addSatellite = function (account) {
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/?account=' + account,
                errorMessage: 'Failed adding satellite to the server',
                disableErrorDialog: true
                //data : module
            });
        };
        satelliteService.saveClientModule = function (satelliteId, module, forceSave) {
            var forceSaveParameter = '';
            if (forceSave) {
                forceSaveParameter = '&forceaccount=true';
            }
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/' + satelliteId + '/' + forceSaveParameter,
                data: module,
                errorMessage: 'Failed saving of the module on server',
                disableErrorDialog: true
            });
        };
        // Not used yet!
        satelliteService.saveClientModuleByAccount = function (autoremindAccount, module) {
            var forcSaveParameter = '';
            if (forceSave) {
                forSaveParameter = '&forceaccount=true';
            }
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/?account=' + autoremindAccount + forcSaveParameter,
                data: module,
                errorMessage: 'Failed saving of the client module by account on server',
                disableErrorDialog: true
            });
        };
        satelliteService.deleteClientModule = function (satelliteId, clientModuleId) {
            return $enhancedHttp({
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/' + satelliteId + '/' + clientModuleId + '/',
                errorMessage: 'Failed deleting client module on server',
                disableErrorDialog: true
            });
        };
        satelliteService.deleteSatellite = function (satelliteId) {
            return $enhancedHttp({
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/' + satelliteId + '/',
                errorMessage: 'Failed deleting satellite on server',
                disableErrorDialog: true
            });
        };
        satelliteService.setSatelliteCheckinMode = function (satelliteId, checkinMode) {
            var data = { 'checkinMode': checkinMode };
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: data,
                url: '/servlets/satellites/' + satelliteId + '/checkinmode/',
                disableErrorDialog: true
            });
        };
        satelliteService.transferLogs = function (satelliteId, transferMode) {
            var data = { 'transferMode': transferMode };
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: data,
                url: '/servlets/satellites/' + satelliteId + '/transferLogs',
                disableErrorDialog: true
            });
        };
        satelliteService.setSatelliteNewVersion = function (satelliteId, newVersion, currentversion) {
            var data = { 'newVersion': newVersion, 'currentVersion': currentversion };
            return $enhancedHttp({
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: data,
                url: '/servlets/satellites/' + satelliteId + '/newversion/',
                disableErrorDialog: true
            });
        };
        satelliteService.resetSatellite = function (satelliteId) {
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/' + satelliteId + '/reset/',
                disableErrorDialog: true
            });
        };
        satelliteService.getLogEventsBySatelliteId = function (satelliteId, lastLogEventId, firstLogEventId) {
            $log.debug('satelliteService.getLogEventsBySatelliteId(' + satelliteId + ',' + lastLogEventId + ', ' + firstLogEventId + ')');
            var deferred = $q.defer();
            $log.debug('satelliteService.getLogEventsBySatelliteId() calling backend');
            $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/log/events/' + satelliteId + '/?lastlogeventid=' + lastLogEventId + '&firstlogeventid=' + firstLogEventId
            })
                .then(function (data, status) {
                //model.inProgress = false;
                deferred.resolve(data); // TODO: Handle errors if no events
            }, function (data, status) {
                //model.inProgress = false;
                $log.error('Error getting log events data from server');
                deferred.reject(status);
            });
            return deferred.promise;
        };
        satelliteService.getCheckins = function (loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/checkins/',
                errorMessage: 'Failed getting satellites from server',
                disableErrorDialog: disableErrorDialog
            }, loadingIndicator);
        };
        satelliteService.getAllSatellites = function (loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/',
                errorMessage: 'Failed getting satellites from server',
                disableErrorDialog: disableErrorDialog
            }, loadingIndicator);
        };
        satelliteService.getLastErrors = function (loadingIndicator, disableErrorDialog) {
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/lasterrors/',
                errorMessage: 'Failed getting last errors from server',
                disableErrorDialog: disableErrorDialog
            }, loadingIndicator);
        };
        satelliteService.getLogEventsByUser = function (userName, lastLogEventId, firstLogEventId, loadingIndicator, disableErrorDialog) {
            $log.debug('satelliteService.getLogEvents(' + userName + ',' + lastLogEventId + ', ' + firstLogEventId + ')');
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                //url: '/servlets/satellites/?logevents=true&lastlogeventid=' + lastLogEventId // TODO: Create servlet to handle logevents as for specific satellite
                url: '/servlets/satellites/logevents/?lastlogeventid=' + lastLogEventId + '&username=' + userName + '&firstlogeventid=' + firstLogEventId,
                errorMessage: 'Failed getting errors by user from server',
                disableErrorDialog: disableErrorDialog
            });
        };
        satelliteService.getUserStatuses = function () {
            if (satelliteService.userstatuses.length > 0) {
                return;
            }
            var self = this;
            var url = '/servlets/satellites/userstatuses/';
            $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                disableErrorDialog: true
            })
                .then(function (data, status) {
                var tmpStatuses = [];
                satelliteService.userstatuses = data.userStatuses;
                for (var x in data.userStatuses) {
                    if (data.userStatuses[x].userStatus && data.userStatuses[x].userStatus.length > 0) {
                        var isExist = false;
                        for (var i in satelliteService.userSchedulerStatuses) {
                            if (satelliteService.userSchedulerStatuses[i].type === 'user' && satelliteService.userSchedulerStatuses[i].id === data.userStatuses[x].userStatus) {
                                isExist = true;
                                break;
                            }
                        }
                        if (!isExist) {
                            tmpStatuses.push({
                                id: data.userStatuses[x].userStatus,
                                name: data.userStatuses[x].userStatus,
                                group: "A",
                                type: 'user',
                                text: 'User: ' + data.userStatuses[x].userStatus
                            });
                        }
                    }
                }
                satelliteService.userSchedulerStatuses = tmpStatuses.concat(satelliteService.userSchedulerStatuses);
            }, function (data, status) {
            });
        };
        satelliteService.satellitesUserSchedulerStatesFilter = function (satellite, selectedModel) {
            if (selectedModel.length === 0 || (selectedModel.length === 1 && !selectedModel[0].id)) {
                return true;
            }
            var atleastOneUser = false;
            var atleastOneScheduler = false;
            var userStatus = false;
            var schedulerState = false;
            for (var i in selectedModel) {
                var selectedStatus = selectedModel[i];
                if (selectedStatus.type === 'user') {
                    atleastOneUser = true;
                    if (satellite.userStatus === selectedStatus.id) {
                        userStatus = true;
                    }
                }
                if (selectedStatus.type === 'scheduler') {
                    atleastOneScheduler = true;
                    if (satellite.schedulerState === selectedStatus.id || selectedStatus.id === 'all') {
                        schedulerState = true;
                    }
                }
            }
            if ((atleastOneUser && atleastOneScheduler && userStatus && schedulerState) ||
                (atleastOneUser && !atleastOneScheduler && userStatus) ||
                (!atleastOneUser && atleastOneScheduler && schedulerState)) {
                return true;
            }
            return false;
        };
        satelliteService.checkModulName = function (dataSource, selectedSatellite) {
            var clientModuleId = 0;
            if (angular.isDefined(dataSource.clientModuleId)) {
                clientModuleId = dataSource.clientModuleId;
            }
            console.log('checkModulName', dataSource, selectedSatellite);
            var url = '/servlets/satellites/checkmodulename/' + selectedSatellite.satelliteId + '/' + clientModuleId + '/' + dataSource.moduleName + '/';
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Error checking the module name',
                disableErrorDialog: true
            });
        };
        satelliteService.loadDatasources = function (satellite) {
            var url = '/servlets/satellites/datasources/' + satellite.satelliteId + '/' + satellite.autoremindAccount + '/';
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Error loading the data sources',
                disableErrorDialog: true
            });
        };
        satelliteService.enableLoadStrategyFromSatellite = function (module) {
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/enableLoadStrategy/',
                data: module,
                errorMessage: 'Failed enable load strategy on server',
                disableErrorDialog: true
            });
        };
        satelliteService.checkIfUserAlreadyHaveDatasource = function (userName, moduleName, loadingIndicator) {
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/satellites/datasource/' + userName + '/',
                data: { moduleName: moduleName },
                errorMessage: 'Failed getting clientmodule details',
                disableErrorDialog: true,
            }, loadingIndicator).then(function (response) {
                return response;
            });
        };
        return satelliteService;
    }]);
//# sourceMappingURL=satellites.services.js.map